import Brief from './Brief';

export default Brief;